if (!!window.navigator.userAgent.match(/MSIE|Trident/) ) {
    var updateBanner = document.querySelector('.c-alert--browser-update');
    var body = document.querySelector('body');

    if (updateBanner) {
        body.insertBefore(updateBanner, body.childNodes[0]);
        updateBanner.style.display = 'block';
    }
}
